import _ from "lodash";

export const entity = {
    name: "AuditControl",
    facets: ["codeName"],
    fields: [
        {path: "auditTheme", type: "AuditTheme"},
        {path: "auditControlType", type: "AuditControlType"},
        {path: "description"},
        {path: "active", type: "boolean", default: true},
        {path: "weight", type: "AuditWeight"}
    ],
    filters:[
        {
            name: "byActiveStatus",
            path: 'activeStatus',
            object: 'ActiveStatus',
            display: "name",
            translate: true,
            client: true,
            default: { id: 'active', name: 'active' },
            isDefault: false,
            query: function(context) {
                const status = _.get(context, 'data.activeStatus')
                return !!status?.id ?
                    status?.id === 'inactive' ? {active: false} : {active: true}
                    : {}
            }
        }
    ]
}

export const module_ = {
    object: "AuditControl",
    tKey: "mTitle_auditControl",
    category: {
        path: "audit",
        icon: "clipboardCheck"
    },
    defaultSortBy: "code",
    defaultSortDirection: "ASC",
    filters: ["byActiveStatus"],
    viewMap: {
        dt: [
            {path: "auditTheme", display: "translatedFullName"},
            {path: "auditControlType", display: "translatedFullName", tKey: "controlType"},
            "code",
            {path: "name", tKey: 'controlSubject', translateName: true},
            {path: 'active', tKey: 'activeStatus', initiallyNotVisible: true}
        ],
        form: [
            {path: "auditTheme", display: "translatedFullName", filters: ["activeThemes"], required: true, editable: false},
            {path: "auditControlType", display: "translatedFullName", tKey: "controlType", filters: ["activeAuditControlTypes"], required: true, editable: false},
            {path: "code", required: true},
            {path: "name", tKey: "controlSubject", type: "textarea", required: true},
            {path: "description", type: "richTextEditor", tKey: 'controlsToPerformAndSuggestions'},
            {path: "weight", display: 'value', tKey: "weight", required: true, default: {id: '1'}},
            {path: "active", type: "booleanToggle", default: true},
        ]
    }
}
